const config = {
	Stores: {
		scope: 'Stores',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/Stores/v1'
				: 'http://localhost:5207',
	},
	Checkout: {
		scope: 'checkout',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/checkout/v4'
				: 'http://localhost:5000',
	},
	Cart: {
		scope: 'cart',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/cart/v11'
				: 'http://localhost:5203',
	},
	AddToCart: {
		scope: 'addToCart',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/addToCart/v7'
				: 'http://localhost:5202',
	},
	AccommodationsBookingFlow: {
		scope: 'accommodationsBookingFlow',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/accommodationsBookingFlow/v5'
				: 'http://localhost:5200',
	},
	CAW: {
		scope: 'caw',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/caw/v4'
				: 'http://localhost:5205',
	},
	Tooltips: {
		scope: 'tooltipController',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/tooltipController/v3'
				: 'http://localhost:5208',
	},
	OpenTable: {
		scope: 'restaurantBookings',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/restaurantBookings/v4'
				: 'http://localhost:5206',
	},
	WebChat: {
		scope: 'WebChat',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/WebChat/v5'
				: 'http://localhost:5210',
	},
	ActivityCalendar: {
		scope: 'activityCalendar',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/activityCalendar/v2'
				: 'http://localhost:5201',
	},
	UserPanel: {
		scope: 'UserPanel',
		url:
			process.env.NODE_ENV === 'production'
				? '/federated/live/UserPanel/v1'
				: 'http://localhost:5209',
	},
};

const remotes = Object.keys(config);
const cachedRemotes = Object.create(null);

async function loadComponent(scope, module) {
	// Initializes the share scope. This fills it with known provided modules from this build and all remotes
	await __webpack_init_sharing__('default');

	// Initialize the container to get shared modules and get the module factory
	const [, factory] = await Promise.all([
		window[scope].init(__webpack_share_scopes__.default),
		window[scope].get(module),
	]);

	return factory().default;
}

function loadRemote(remote) {
	return new Promise((resolve, reject) => {
		if (remotes.includes(remote)) {
			if (!cachedRemotes[remote]) {
				const element = document.createElement('script');
				element.src = `${config[remote].url}/remoteEntry.js`;
				element.type = 'text/javascript';
				element.async = true;

				element.onload = () => {
					cachedRemotes[remote] = loadComponent(config[remote].scope, `./${remote}`);
					resolve(cachedRemotes[remote]);
				};
				element.onerror = (event, source, lineno, colno, error) => {
					reject(error);
				};

				document.head.appendChild(element);
			} else {
				resolve(cachedRemotes[remote]);
			}
		} else {
			reject(new Error('Invalid remote'));
		}
	});
}

export { loadRemote };
